<div class="container" [algFullHeightContent]="true">
  <alg-error i18n-message message="Oops… We didn’t find that page"
    icon="ph-duotone ph-warning-circle"
    link="/"
    i18n-buttonCaption buttonCaption="Back to home page"
   />
</div>

